export class ErrorSmallPopup {
    private static instance: ErrorSmallPopup;
    private popupElement: JQuery<HTMLDivElement>;
    private closeBtn: JQuery<HTMLElement>;

    private constructor() {
        this.popupElement = $('.error-popup');
        this.closeBtn = this.popupElement.find('.close-btn');
    }

    public setButtonText(buttonLabel: string) {
        this.popupElement.find('.support_but').text(buttonLabel);
    }

    public setTitle(title: string) {
        this.popupElement.find('.error-popup__title').text(title);
    }

    public setMessage(message: string, html: boolean = false) {
        if (html === true) {
            this.popupElement.find('.error-popup__message').html(message);
        } else {
            this.popupElement.find('.error-popup__message').text(message);
        }
    }

    public setHtmlMessage(message: string) {
        this.popupElement.find('.error-popup__message').html(message);
    }

    public setCallback(callback: Function) {
        this.popupElement.find('.support_but').one('click', () => {
            this.closeBtn.hide();
            this.hide();

            if (callback) {
                callback();
            }
        });
    }

    public enableCloseBtn(): void {
        this.closeBtn.show();
        this.closeBtn.one('click', () => {
            this.closeBtn.hide();
            this.hide();
        });
    }

    public show() {
        this.popupElement.show();
    }

    public hide() {
        this.popupElement.hide();
    }

    public static getInstance() {
        if (typeof ErrorSmallPopup.instance === 'undefined') {
            ErrorSmallPopup.instance = new ErrorSmallPopup();
        }

        return ErrorSmallPopup.instance;
    }
}
